import { post } from './authRequest'

export const AUTH_API_TOKEN_INFO = "/token-info"

export const verifyToken = (token) => post(AUTH_API_TOKEN_INFO, { token})
